module.exports = __webpack_public_path__ + "img/puzzle4_b7.997a31cf.png";